module.exports = __webpack_public_path__ + "5cdb08ae244fad3e7b4a74150931259e.jpg";